import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeroSection } from '../components/hero/HeroSection';
import { ProjectList } from '../components/projects/ProjectList';
import { ProjectSkeleton } from '../components/loading/ProjectSkeleton';
import { Project } from '../types/project';
import { projects } from '../data/projects';

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [projectData, setProjectData] = useState<Project[]>([]);

  useEffect(() => {
    const loadProjects = async () => {
      setIsLoading(true);
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));
        setProjectData(projects);
      } catch (error) {
        console.error('Error loading projects:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadProjects();
  }, []);

  return (
    <>
      <div className="flex-shrink-0">
        <HeroSection />
      </div>

      <div className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <div className="h-[calc(100vh-24rem)]">
          <AnimatePresence mode="wait">
            {isLoading ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="h-full"
              >
                <ProjectSkeleton count={6} />
              </motion.div>
            ) : (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="h-full"
              >
                <ProjectList projects={projectData} />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </>
  );
}
